import { Button, ButtonProps } from '@/shadcn-ui/button';
import useRouteIsLoading from '@/util-react-router/hooks/use-route-is-loading';
import React, { useEffect } from 'react';

export const LoaderButton = React.forwardRef<
  HTMLButtonElement,
  Omit<ButtonProps, 'loading'>
>(({ disabled, type, ...props }: Omit<ButtonProps, 'loading'>, ref) => {
  const [hasBeenClicked, setHasBeenClicked] = React.useState(false);
  const isLoading = useRouteIsLoading() && !disabled;
  const isSubmitting = type === 'submit' && hasBeenClicked;

  const compositeOnClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    if (disabled || isLoading) {
      event.preventDefault();
      return;
    }

    setHasBeenClicked(true);

    if (props.onClick) {
      props.onClick(event);
    }
  };

  useEffect(() => {
    if (!isLoading) {
      setHasBeenClicked(false);
    }
  }, [isLoading]);

  return (
    <Button
      {...props}
      disabled={disabled || isLoading || isSubmitting}
      onClick={compositeOnClick}
      loading={isLoading ? hasBeenClicked : undefined}
      ref={ref}
      type={type}
    />
  );
});

LoaderButton.displayName = 'LoaderButton';
